<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text="Free Email Service Providers" jsonKey="supportFreeEmailService" />
    </div>
    <div class="body">
        <div class="content intsructions">
            <div>
                <mwp-text-translate text="To register with MyWorkplace.net you will need a valid email address, a cell phone with SMS capabilities, or access to telephone. If you do not have an email address you may obtain one at any number of free email providers available on the Internet. For your convenience, please find links to three of the more popular email providers below." jsonKey="supportNote1" />
            </div>
            <div class="container-email-services modal-box w-100">
                <div class="d-inline-flex justify-content-center browser-panel mx-4">
                    <a href="https://accounts.google.com/SignUp" class="browser-icon gmail me-4" target="_blank">
                        <div class="d-flex justify-content-center mb-1">
                            <img src="assets/images/Gmail_Logo.svg" alt="Gmail Logo" />
                        </div>
                        <div>Gmail</div>
                    </a>
                    <a href="https://login.yahoo.com/account/create" class="browser-icon yahoo me-4" target="_blank">
                        <div class="d-flex justify-content-center mb-1 mt-1">
                            <img src="assets/images/Yahoo_Mail_Logo.svg" alt="Yahoo! Mail Logo" />
                        </div>
                        <div>Yahoo! Email</div>
                    </a>
                    <a href="https://signup.live.com" class="browser-icon outlook" target="_blank">
                        <div class="d-flex justify-content-center mb-1 mt-1">
                            <img src="assets/images/Outlook_Logo.webp" alt="Outlook Logo" />
                        </div>
                        <div>Outlook</div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="header">
        <mwp-text-translate text="Supported Browsers" jsonKey="supportedBrowsers" />
    </div>
    <div class="body">
        <div class="content intsructions">
            <div>
                <mwp-text-translate text="Supported browsers for MyWorkplace.net are listed below. You may obtain the latest version of any of these browsers by
                        clicking its icon." jsonKey="supportNote2" />
            </div>
            <div class="d-flex justify-content-center">
                <div class="container-email-services modal-box w-100">
                    <div class="d-inline-flex justify-content-center browser-panel mx-4">
                        <a href="https://www.google.com/chrome/browser/desktop/" class="browser-icon gmail me-4" target="_blank">
                            <div class="d-flex justify-content-center mb-1">
                                <img src="assets/images/Chrome_Logo.svg" alt="Google Chrome Logo" />
                            </div>
                            <div>Google Chrome</div>
                        </a>
                        <a href="https://www.mozilla.org/en-US/firefox/new/" class="browser-icon me-4" target="_blank">
                            <div class="d-flex justify-content-center mb-1 mt-1">
                                <img src="assets/images/Firefox_Logo.svg" alt="Mozilla FireFox Logo" />
                            </div>
                            <div>Mozilla Firefox</div>
                        </a>
                        <a href="https://support.apple.com/downloads/safari" class="browser-icon me-4" target="_blank">
                            <div class="d-flex justify-content-center mb-1 mt-1">
                                <img src="assets/images/Safari_Logo.svg" alt="Apple Safari Logo" />
                            </div>
                            <div>Apple Safari</div>
                        </a>
                        <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" class="browser-icon" target="_blank">
                            <div class="d-flex justify-content-center mb-1 mt-1">
                                <img src="assets/images/Edge_Logo.svg" alt="Microsoft Edge Logo" />
                            </div>
                            <div>Microsoft Edge</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <button class="mwp-button-secondary w-100" (click)="close()">
            <mwp-text-translate text="Close" jsonKey="close" />
        </button>
    </div>
</div>